export default __webpack_public_path__ + "locales/ar-SA/Ldap.json?hash=6db3f1dbbe246638f0368a910139cc7c";